import { useIntersectionObserver } from 'hooks/useIntersectionObserver/useIntersectionObserver'
import {
	useProductList,
	useProductListView,
} from 'product-list/hooks/useProductList/useProductList'
import { type RefObject, useCallback, useEffect } from 'react'
import { usePageSize } from '../usePageSize/usePageSize'

export const VIRTUAL_ITEM_CLASS = 'virtual-item'
export const VIRTUAL_LIST_CLASS = 'virtual-list'

export function useVirtualPages(itemElement: RefObject<Element | null>) {
	const view = useProductListView()
	const { increaseCount } = useProductList()

	const pageSize = usePageSize(view)

	const next = useCallback(
		() => increaseCount(pageSize),
		[increaseCount, pageSize]
	)

	const entry = useIntersectionObserver(itemElement, {
		rootMargin: '0px 0px 100% 0px',
		threshold: [0, 1],
	})

	useEffect(() => {
		if (entry?.isIntersecting) {
			next()
		}
	}, [entry, next])
}
